import React, {
    useEffect,
    useState,
    forwardRef,
    useImperativeHandle,
} from "react";
import { toast } from "react-toastify";
import API from "../Services/Report";
import API1 from "../Services/DiscountReport";
import * as XLSX from "xlsx";

const DiscountReport = forwardRef(
    ({ filters, selectedCenter, resetTrigger, applyTrigger, dateTrigger, radioFilter }, ref) => {

        const [discountSummary, setDiscountSummary] = useState({});
        const [loading, setLoading] = useState(false);
        const [response, setResponse] = useState([]);
        const [responseCount, setResponseCount] = useState(0);
        const [discountType, setDiscountType] = useState(null);
        const [currentPage, setCurrentPage] = useState(1);
        const [totalPages, setTotalPages] = useState(1);
        const [consolidatedCuoponReport, setConsolidatedCuoponReport] = useState([]);
        const [couponDiscountCount, setCouponDiscountCount] = useState(0);
        const [couponList, setCouponList] = useState([]);
        const [showAdhock, setShowAdhock] = useState(false);
        const [showCoupon, setShowCoupon] = useState(false);
        const [showRechargeCoupon, setShowRechargeCoupon] = useState(false);
        const recordsPerPage = 10;
        const [couponType, setCouponType] = useState(null);

        const [columnTotals, setColumnTotals] = useState({
            order_amount: 0,
            bill_amount: 0,
            discount_amount: 0,
        });
        const today = new Date();
        const formattedToday = today.toISOString().split("T")[0];
        const pastDate = new Date();
        pastDate.setDate(pastDate.getDate() - 90);
        const formattedPastDate = pastDate.toISOString().split("T")[0];

        const safeJSON = (str) => {
            try {
                return JSON.parse(str || "{}");
            } catch {
                return {};
            }
        };

        const buildPayload = (filters, selectedCenter, page, recordsPerPage) => {
            const centerlist = Array.isArray(selectedCenter)
                ? selectedCenter.join(",")
                : selectedCenter;

            return {
                start_date: filters.startDate || formattedPastDate,
                end_date: filters.endDate || formattedToday,
                location_id: centerlist && centerlist.length > 0 ? centerlist : null,
                page_number: page,
                limit: recordsPerPage
            };
        };
        const buildPayload1 = (filters, selectedCenter, page, recordsPerPage) => {
            const centerlist = Array.isArray(selectedCenter)
                ? selectedCenter.join(",")
                : selectedCenter;

            return {
                start_date: filters.startDate || formattedPastDate,
                end_date: filters.endDate || formattedToday,
                location_id: centerlist && centerlist.length > 0 ? centerlist : null,
                page_number: page,
                limit: responseCount
            };
        };

        const getDiscountSummaryData = async (page = 1) => {
            try {
                const payloadData = buildPayload(filters, selectedCenter, page, recordsPerPage);

                setLoading(true);
                const response = await API.getDiscountSummary(payloadData);

                if (response?.data?.result?.length > 0) {
                    const data = response.data.result[0];

                    setDiscountSummary({
                        recharge: safeJSON(data.recharge),
                        combo_product: safeJSON(data.combo_product),
                        party_discount: safeJSON(data.party_discount),
                    });
                } else {
                    toast.warn("No discount summary data found");
                    setDiscountSummary({});
                }
            } catch {
                toast.error("Failed to load discount summary");
            } finally {
                setLoading(false);
            }
        };

        const getPlayPointsDiscountReport = async (page = 1) => {
            try {
                const payloadData = buildPayload(filters, selectedCenter, page, recordsPerPage);

                const response = await API1.getPlayPointsDiscountReport(payloadData);

                if (response?.status === 200 && Array.isArray(response.data.result)) {
                    const list = response.data.result;
                    const total = response.data.total_count ?? list.length;

                    setResponse(list);
                    setResponseCount(total);
                    calculateTotals(list);

                    setTotalPages(Math.ceil(total / recordsPerPage));
                    setCurrentPage(page);
                } else {
                    toast.error("No Recharge Discount data found");
                    setResponse([]);
                }
            } catch {
                toast.error("Error fetching PlayPointsDiscount report");
                setResponse([]);
            }
        };

        const getProductDiscountReport = async (page = 1) => {
            try {
                const payloadData = buildPayload(filters, selectedCenter, page, recordsPerPage);
                const response = await API1.getProductDiscountReport(payloadData);

                if (response?.data?.success && Array.isArray(response.data.result)) {
                    const list = response.data.result;
                    const total = response.data.total_count || list.length;

                    setResponse(list);
                    setResponseCount(total);
                    setTotalPages(Math.ceil(total / recordsPerPage));
                    setCurrentPage(page);
                    // calculateTotals(list);
                    calculateComboTotals(list);

                } else {
                    toast.error("No Product Discount data found");
                    setResponse([]);
                    setResponseCount(0);
                }
            } catch (error) {
                toast.error(error?.response?.data?.message || error.message);
                setResponse([]);
                setResponseCount(0);
            }
        };

        const getPartyDiscountReport = async (page = 1) => {
            try {
                const payloadData = buildPayload(filters, selectedCenter, page, recordsPerPage);

                const response = await API1.getPartyDiscountReport(payloadData);

                if (response?.data?.success && Array.isArray(response.data.result)) {
                    const list = response.data.result;
                    const total = response.data.total_count || 0;

                    setResponse(list);
                    setResponseCount(total);
                    setCurrentPage(page);
                    setTotalPages(Math.ceil(total / recordsPerPage));
                    // calculateTotals(list);
                    calculatePartyTotals(list);
                } else {
                    toast.error("No Party Discount data found");
                    setResponse([]);
                    setResponseCount(0);
                }
            } catch (error) {
                toast.error(error?.response?.data?.message || "Error fetching party discount report");
                setResponse([]);
                setResponseCount(0);
            }
        };
        const getConsolidatedCuoponReport = async (page = 1) => {

            try {
                const payloadData = buildPayload(filters, selectedCenter, page, recordsPerPage);
                const response = await API1.getConsolidatedCuoponReport(payloadData);
                if (response.data?.success) {
                    setConsolidatedCuoponReport(response?.data.result || []);
                } else {
                    setConsolidatedCuoponReport([]);
                }
            } catch (error) {
                toast.error("Something went wrong while fetching report");
                setConsolidatedCuoponReport([]);
            }
        };

        // useEffect(() => {
        // console.log('resetTrigger', resetTrigger, applyTrigger,discountType,radioFilter);
        //     if (applyTrigger === 0 && resetTrigger === 0 && radioFilter === "") return;

        //     if (applyTrigger > 0) {

        //         if (radioFilter !== "adhock") return;

        //         if (!discountType) return;

        //         if(radioFilter==="adhock" && discountType===null)
        //             getDiscountSummaryData(1)

        //         switch (discountType) {
        //             case "recharge":
        //                 getPlayPointsDiscountReport(1);
        //                 break;

        //             case "combo_product":
        //                 getProductDiscountReport(1);
        //                 break;

        //             case "party_discount":
        //                 getPartyDiscountReport(1);
        //                 break;

        //             default:
        //                 return;
        //         }
        //     }
        //     if (radioFilter === "adhock") {
        //         console.log('ffffff');
        //         setShowAdhock(true);
        //         setShowCoupon(false);
        //         getDiscountSummaryData(1);
        //     } else {
        //         setShowCoupon(true);
        //         setShowAdhock(false);
        //         getConsolidatedCuoponReport(1);
        //     }

        // }, [applyTrigger, resetTrigger, radioFilter]);


        useEffect(() => {
            // console.log('resetTrigger', resetTrigger, applyTrigger, discountType, radioFilter);

            if (applyTrigger === 0 && resetTrigger === 0 && radioFilter === "") return;

            if (radioFilter === "adhock" && discountType === null) {
                setShowAdhock(true);
                setShowCoupon(false);
                getDiscountSummaryData(1);
            } else {
                setShowCoupon(true);
                setShowAdhock(false);
                getConsolidatedCuoponReport(1)
            }

            if (applyTrigger > 0) {
                if (radioFilter !== "adhock" || !discountType) return;

                switch (discountType) {
                    case "recharge":
                        getPlayPointsDiscountReport(1);
                        break;

                    case "combo_product":
                        getProductDiscountReport(1);
                        break;

                    case "party_discount":
                        getPartyDiscountReport(1);
                        break;

                    default:
                        getDiscountSummaryData(1);
                }

                return;
            }

            // if (radioFilter === "adhock") {
            //     //console.log('dddd')
            //     getDiscountSummaryData(1);
            // } else {
            //     getConsolidatedCuoponReport(1);
            // }

        }, [applyTrigger, resetTrigger, radioFilter]);


        const handlePageChange = (page) => {
            if (page < 1 || page > totalPages) return;

            setCurrentPage(page);

            if (discountType === "recharge") getPlayPointsDiscountReport(page);
            if (discountType === "combo_product") getProductDiscountReport(page);
            if (discountType === "party_discount") getPartyDiscountReport(page);
        };

        const getPageNumbers = () => {
            const maxVisible = 10;
            const pageNumbers = [];
            if (totalPages <= maxVisible) {
                for (let i = 1; i <= totalPages; i++) {
                    pageNumbers.push(i);
                }
            } else {
                const left = Math.max(1, currentPage - 3);
                const right = Math.min(totalPages, currentPage + 3);

                if (left > 2) {
                    pageNumbers.push(1, "...");
                } else {
                    for (let i = 1; i < left; i++) {
                        pageNumbers.push(i);
                    }
                }
                for (let i = left; i <= right; i++) {
                    pageNumbers.push(i);
                }
                if (right < totalPages - 1) {
                    pageNumbers.push("...", totalPages);
                } else {
                    for (let i = right + 1; i <= totalPages; i++) {
                        pageNumbers.push(i);
                    }
                }
            }
            return pageNumbers;
        };
        useEffect(() => {
            if (radioFilter !== "adhock") return;
            if (!discountType) return;
            if (discountType === "recharge") {
                getPlayPointsDiscountReport(1);
            }
            else if (discountType === "combo_product") {
                getProductDiscountReport(1);
            }
            else if (discountType === "party_discount") {
                getPartyDiscountReport(1);
            }

        }, [discountType]);

        const handleCardClick = (type) => {
            setDiscountType(type);

            setTimeout(() => {
                if (radioFilter !== "adhock") return;
                if (type === "recharge") getPlayPointsDiscountReport(1);
                if (type === "combo_product") getProductDiscountReport(1);
                if (type === "party_discount") getPartyDiscountReport(1);
            }, 0);
        };

        const getCardStyle = (type, bg) => ({
            background: bg,
            borderRadius: "12px",
            padding: "16px",
            width: "32%",
            cursor: "pointer",
            border: discountType === type ? "2px solid #1976d2" : "2px solid transparent",
            boxShadow: discountType === type
                ? "0 5px 14px rgba(25,118,210,0.35)"
                : "0 2px 6px rgba(0,0,0,0.1)",
            transform: discountType === type ? "scale(1.03)" : "scale(1)",
            transition: "all 0.2s ease",
        });
        const titleMapping = {
            recharge: "Recharge",
            combo_product: "Combo Product",
            party_discount: "Party Discount"
        };

        const titleCouponMapping = {
            pack: "Packages",
            recharge: "Recharges"
        };

        const getDiscountColumnTitle = () => {
            if (discountType === "recharge") return "Discount";
            if (discountType === "combo_product") return "Manual Discount";
            if (discountType === "party_discount") return "Discount Amount	";
            return "Discount";
        };
        const getDiscountValue = (item) => {
            if (discountType === "recharge") return item.discount_amount;
            if (discountType === "combo_product") return item.manual_discount;
            if (discountType === "party_discount") return item.discount_amount;
            return item.discount_amount;
        };

        const getBillAmountColumnValue = (item) => {
            if (discountType === "recharge") return item.bill_amount;
            if (discountType === "combo_product") return item.bill_amount;
            if (discountType === "party_discount") return item.bill_amont;
            return item.discount_amount;
        };
        const handleClick = async (type) => {
            ///console.log('type', type);
            setCouponType(type);
            if (type === "recharge") {
                await getPlayPointsCuoponReport(1);
            } else {
                await getPackageCuoponReport(1);
            }
            setShowRechargeCoupon(true);
        };

        const getPlayPointsCuoponReport = async (page = 1) => {
          const payloadData = buildPayload(filters, selectedCenter, page, recordsPerPage);
            const response = await API1.getPlayPointsCuoponReport(payloadData);

            const result = response?.data?.result || [];

            const totalRecords = result[0]?.total_records || 0;

            const list = result.slice(1);

            setCouponDiscountCount(totalRecords);
            setCouponList(list);
            calculateCouponTotals(list);

            //console.log("Recharge Result:", list);
            //console.log("Total Records:", totalRecords);
        };

        const getPackageCuoponReport = async (page = 1) => {
            const payloadData = buildPayload(filters, selectedCenter, page, recordsPerPage);
            const response = await API1.getPackageCuoponReport(payloadData);

            const list = response?.data?.result || [];

            const totalRecords = list.length;

            setCouponDiscountCount(totalRecords);
            setCouponList(list);
            calculateCouponTotals(list);

        };
        const downloadCSV = async () => {
            // if (responseCount <= 0 || couponDiscountCount <= 0) {
            //     toast.info("No data available for download");
            //     return;
            // }
            if (responseCount <= 0) {
                toast.info("No data available for download");
                return;
            }
            try {
                let response = null;
                let sheetName = "";
                let fileName = "";

                const payloadData = buildPayload1(filters, selectedCenter, responseCount);

                //  Adhoc - Recharge Report
                if (radioFilter === "adhock" && discountType === "recharge") {
                    response = await API1.getPlayPointsDiscountReport(payloadData);
                    sheetName = "RechargeReport";
                    fileName = "RechargeReport.xlsx";
                }

                //  Adhoc - Combo Product Report
                else if (radioFilter === "adhock" && discountType === "combo_product") {
                    response = await API1.getProductDiscountReport(payloadData);
                    sheetName = "ComboProductDiscountReport";
                    fileName = "ComboProductDiscountReport.xlsx";
                }

                //  Adhoc - Party Discount Report
                else if (radioFilter === "adhock" && discountType === "party_discount") {
                    response = await API1.getPartyDiscountReport(payloadData);
                    sheetName = "PartyDiscountReport";
                    fileName = "PartyDiscountReport.xlsx";
                }
                else if (radioFilter === "coupon" && couponType === "recharge") {
                    const centerlist = Array.isArray(selectedCenter)
                        ? selectedCenter.join(",")
                        : selectedCenter;

                    const payloadData1 = {
                        start_date: filters.startDate || formattedPastDate,
                        end_date: filters.endDate || formattedToday,
                        location_id: centerlist && centerlist.length > 0 ? centerlist : null,
                        page_number: 1,
                        limit: couponDiscountCount
                    };

                    response = await API1.getPlayPointsCuoponReport(payloadData1);
                    sheetName = "RechargeDiscountReport";
                    fileName = "RechargeDiscountReport.xlsx";
                }

                else if (radioFilter === "coupon" && couponType === "pack") {
                    // console.log("Coupon Pack Type");
                    const centerlist = Array.isArray(selectedCenter)
                        ? selectedCenter.join(",")
                        : selectedCenter;

                    const payloadData1 = {
                        start_date: filters.startDate || formattedPastDate,
                        end_date: filters.endDate || formattedToday,
                        location_id: centerlist && centerlist.length > 0 ? centerlist : null,
                        page_number: 1,
                        limit: couponDiscountCount
                    };

                    response = await API1.getPackageCuoponReport(payloadData1);
                    sheetName = "PackageCouponReport";
                    fileName = "PackageCouponReport.xlsx";
                }


                const result = response?.data?.result;
                if (!Array.isArray(result) || result.length === 0) {
                    toast.error("No data available for download");
                    return;
                }
                const worksheet = XLSX.utils.json_to_sheet(result);
                const workbook = XLSX.utils.book_new();

                XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
                XLSX.writeFile(workbook, fileName);

            } catch (error) {
                console.error("Excel Download Failed:", error);
                toast.error("Failed to download report");
            }
        };

        useImperativeHandle(ref, () => ({
            downloadCSV,
        }));

        const calculateTotals = (data) => {
            let { orderAmountSum, billAmountSum, discountAmountSum } = {
                orderAmountSum: 0,
                billAmountSum: 0,
                discountAmountSum: 0
            };

            data.forEach(item => {
                orderAmountSum += Number(item.order_amount) || 0;
                billAmountSum += Number(item.bill_amount) || 0;

                const discount =
                    radioFilter === "adhock" && discountType === "combo_product"
                        ? item.manual_discount
                        : item.discount_amount;
                discountAmountSum += Number(discount) || 0;
            });

            setColumnTotals({
                order_amount: orderAmountSum,
                bill_amount: billAmountSum,
                discount_amount: discountAmountSum,
            });
        };

        const calculateCouponTotals = (data) => {
            let orderAmountSum = 0;
            let discountAmountSum = 0;

            data.forEach(item => {
                orderAmountSum += Number(item.order_amount) || 0;
                discountAmountSum += Number(item.coupon_discount_amount) || 0;
            });

            setColumnTotals({
                order_amount: orderAmountSum,
                discount_amount: discountAmountSum
            });
        };

        const calculateComboTotals = (data) => {
            let orderAmountSum = 0;
            let discountAmountSum = 0;
            let billAmountSum = 0

            data.forEach(item => {
                orderAmountSum += Number(item.order_amount) || 0;
                discountAmountSum += Number(item.manual_discount) || 0;
                billAmountSum += Number(item.bill_amount);
            });

            setColumnTotals({
                order_amount: orderAmountSum,
                discount_amount: discountAmountSum,
                bill_amount: billAmountSum
            });
        };

        const calculatePartyTotals = (data) => {
            let orderAmountSum = 0;
            let discountAmountSum = 0;
            let billAmountSum = 0;
            data.forEach(item => {
                orderAmountSum += Number(item.order_amount) || 0;
                discountAmountSum += Number(item.discount_amount) || 0;
                billAmountSum += Number(item.bill_amont) || 0;
            });

            setColumnTotals({
                order_amount: orderAmountSum,
                discount_amount: discountAmountSum,
                bill_amount: billAmountSum
            });
        };


        return (
            <div>
                {showAdhock && (
                    <div className="card p-0">
                        <div className="p-4">

                            {loading ? (
                                <p className="text-center fw-semibold">Loading...</p>
                            ) : Object.keys(discountSummary).length > 0 ? (
                                <div className="d-flex flex-wrap justify-content-between">

                                    {/* Recharge */}
                                    <div
                                        style={getCardStyle("recharge", "#e8f5e9")}
                                        onClick={() => handleCardClick("recharge")}
                                    >
                                        <h6 className="fw-bold text-uppercase mb-2">Recharge</h6>
                                        <hr />
                                        <p>Count: {discountSummary.recharge?.count || 0}</p>
                                        <p>Amount: ₹{discountSummary.recharge?.amount || 0}</p>
                                    </div>

                                    {/* Combo Product */}
                                    <div
                                        style={getCardStyle("combo_product", "#fff8e1")}
                                        onClick={() => handleCardClick("combo_product")}
                                    >
                                        <h6 className="fw-bold text-uppercase mb-2">Combo Product</h6>
                                        <hr />
                                        <p>Count: {discountSummary.combo_product?.count || 0}</p>
                                        <p>Amount: ₹{discountSummary.combo_product?.amount || 0}</p>
                                    </div>

                                    {/* Party */}
                                    <div
                                        style={getCardStyle("party_discount", "#e3f2fd")}
                                        onClick={() => handleCardClick("party_discount")}
                                    >
                                        <h6 className="fw-bold text-uppercase mb-2">Party Discount</h6>
                                        <hr />
                                        <p>Count: {discountSummary.party_discount?.count || 0}</p>
                                        <p>Amount: ₹{discountSummary.party_discount?.amount || 0}</p>
                                    </div>
                                </div>
                            ) : (
                                <p className="text-center">No summary data available</p>
                            )}

                        </div>



                    </div>
                )}
                {showAdhock && responseCount > 0 && (
                    <div className="card mt-4">
                        <div className="modern-table-container">
                            <div className="modern-table-header">
                                <h4 className="card-title mb-0">
                                    {titleMapping[discountType] || ""} (<b>{responseCount}</b>)
                                </h4>
                            </div>

                            <div className="card-body p-0">
                                <div className="table-responsive">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Customer Name</th>
                                                <th>Customer Mobile</th>
                                                <th>Employee Name</th>
                                                {discountType !== "party_discount" && (
                                                    <th>Product Name</th>
                                                )}
                                                <th>Order Amount</th>
                                                <th>Bill Amount</th>
                                                <th>{getDiscountColumnTitle()}</th>

                                                <th>Date</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {response.length > 0 ? (
                                                response.map((item, i) => (
                                                    <tr key={i}>
                                                        <td>{(currentPage - 1) * recordsPerPage + i + 1}</td>
                                                        <td>{item.customer_name}</td>
                                                        <td>{item.customer_mobile}</td>
                                                        <td>{item.employee_name}</td>

                                                        {discountType !== "party_discount" && (
                                                            <td>{item.product_names}</td>
                                                        )}

                                                        <td>{item.order_amount}</td>
                                                        <td>{getBillAmountColumnValue(item)}</td>
                                                        <td>{getDiscountValue(item)}</td>
                                                        <td>{item.createdAt}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="8" className="text-center text-danger">
                                                        No Records Found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                        {/* <tfoot>
                                            <tr>
                                                <th></th>
                                                <th></th>
                                                <th></th>

                                                {discountType === "party_discount" ? null : <th></th>}

                                                <th style={{ textAlign: "right" }}>Total</th>
                                                <th>{columnTotals.order_amount}</th>
                                                <th>{columnTotals.bill_amount}</th>
                                                <th>{columnTotals.discount_amount}</th>
                                            </tr>
                                        </tfoot> */}


                                    </table>

                                    <nav>
                                        <ul className="pagination justify-content-center mt-4">
                                            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                                <button className="page-link"
                                                    onClick={() => handlePageChange(currentPage - 1)}>
                                                    Previous
                                                </button>
                                            </li>
                                            {getPageNumbers().map((page, index) => (
                                                <li
                                                    key={index}
                                                    className={`page-item ${page === currentPage ? "active" : ""
                                                        } ${page === "..." ? "disabled" : ""}`}
                                                >
                                                    {page === "..." ? (
                                                        <span className="page-link">...</span>
                                                    ) : (
                                                        <button
                                                            className="page-link"
                                                            onClick={() => handlePageChange(page)}
                                                        >
                                                            {page}
                                                        </button>
                                                    )}
                                                </li>
                                            ))}

                                            {/* {getPageNumbers().map((pg, i) => (
                                                <li key={i} className={`page-item ${pg === currentPage ? "active" : ""}`}>
                                                    <button className="page-link"
                                                        onClick={() => handlePageChange(pg)}>
                                                        {pg}
                                                    </button>
                                                </li>
                                            ))} */}

                                            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                                <button className="page-link"
                                                    onClick={() => handlePageChange(currentPage + 1)}>
                                                    Next
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>

                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {showCoupon && (

                    <div className="card p-0">
                        <table className="table  table-bordered text-center">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Coupon Code</th>
                                    <th>Recharge(Count/Amount)</th>
                                    <th>Package(Count/Amount)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {consolidatedCuoponReport.length > 0 ? (
                                    consolidatedCuoponReport.map((item, index) => {
                                        const recharge = safeJSON(item.recharge);
                                        const pack = safeJSON(item.package);

                                        return (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{item.code}</td>

                                                <td>

                                                    <button
                                                        className="btn btn-link btn-sm"
                                                        onClick={() => handleClick("recharge")}
                                                    >
                                                        {recharge?.count}
                                                    </button>

                                                    / {recharge?.amount || 0}
                                                </td>

                                                <td>
                                                    <button className="btn btn-link btn-sm" onClick={() => handleClick("pack")}>
                                                        {pack?.count}
                                                    </button>
                                                    / {pack?.amount || 0}
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="4">No Data Found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                    </div>
                )}

                {showRechargeCoupon === true && (
                    <div
                        className="modal fade show"
                        // id={id}
                        tabIndex="-1"
                        aria-hidden="true"
                        onClick={() => setShowRechargeCoupon(false)}
                        style={{
                            display: "block",
                            background: "rgba(0,0,0,0.5)"
                        }}
                    >
                        <div className="modal-dialog modal-lg" onClick={(e) => e.stopPropagation()}>
                            <div className="modal-content">
                                <div className="modal-header d-flex justify-content-between align-items-center w-100">
                                    <h5 className="modal-title">
                                        Coupon Discount Report for {titleCouponMapping[couponType] || ""}
                                    </h5>

                                    <div className="d-flex align-items-center gap-2">
                                        <button className="btn btn-primary btn-sm" onClick={downloadCSV}>
                                            <i className="fa fa-download"></i>
                                        </button>

                                        <button type="button" className="btn-close" onClick={() => setShowRechargeCoupon(false)}></button>
                                    </div>
                                </div>

                                <div className="modal-body">
                                    <div className="card p-0">
                                        <table className="table  table-bordered text-center">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Customer Name</th>
                                                    <th>Customer Mobile</th>
                                                    <th>Coupon Code</th>
                                                    <th>Order Amount</th>
                                                    <th>Coupon Discount Amount</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {couponList.length > 0 ? (
                                                    couponList.map((item, index) => (
                                                        <tr key={item.id}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.customer_name ?? "N/A"}</td>
                                                            <td>{item.customer_mobile}</td>
                                                            <td>{item.coupon_code}</td>
                                                            <td>{item.order_amount}</td>
                                                            <td>{item.coupon_discount_amount}</td>
                                                            <td>{item.createdAt}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="7" className="text-center">
                                                            No Data Found
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <th></th>
                                                    <th></th>
                                                    <th></th>
                                                    <th>Total</th>

                                                    <th>{columnTotals.order_amount.toFixed(2)}</th>
                                                    <th>{columnTotals.discount_amount.toFixed(2)}</th>
                                                </tr>
                                            </tfoot>
                                        </table>
                                        <nav>
                                            <ul className="pagination justify-content-center mt-4">
                                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                                    <button
                                                        className="page-link"
                                                        onClick={() => handlePageChange(currentPage - 1)}
                                                    >
                                                        Previous
                                                    </button>
                                                </li>

                                                {getPageNumbers().map((page, index) => (
                                                    <li
                                                        key={index}
                                                        className={`page-item ${page === currentPage ? "active" : ""}`}
                                                    >
                                                        <button className="page-link" onClick={() => handlePageChange(page)}>
                                                            {page}
                                                        </button>
                                                    </li>
                                                ))}

                                                <li
                                                    className={`page-item ${currentPage === totalPages ? "disabled" : ""
                                                        }`}
                                                >
                                                    <button
                                                        className="page-link"
                                                        onClick={() => handlePageChange(currentPage + 1)}
                                                    >
                                                        Next
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>


                )}

            </div>
        );
    }
);

export default DiscountReport;
